import { render } from "./detailsPage.vue?vue&type=template&id=5f1c9b2e&scoped=true"
import script from "./detailsPage.vue?vue&type=script&lang=js"
export * from "./detailsPage.vue?vue&type=script&lang=js"

import "./detailsPage.vue?vue&type=style&index=0&id=5f1c9b2e&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/funfindhk20250610/front-vue-src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1c9b2e"]])

export default __exports__